import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

function ThankPage() {
  const location = useLocation();
  const [urlCode, setUrlCode] = useState(null);
  const [craftTag, setCraftTag] = useState(null);
  const [carrotTag, setCarrotTag] = useState(null);

  // const googletag = "AW-16633997164";
  // const googletag2 = "AW-16455049727";
  // const googletagNew = "AW-16455053593";
  // const googletagNew2 = "AW-16455043088";

  useEffect(() => {
    if (location.state) {
      const { urlCode, craftTag, carrotTag } = location.state;
      setUrlCode(urlCode);

      setCraftTag(craftTag);
      setCarrotTag(carrotTag);
    }
  }, [location.state]);

  useEffect(() => {
    const incrementEndpageMountCount = async () => {
      if (!urlCode) return;
      try {
        await axios.post(`/api/endpage/${urlCode}`);
      } catch (error) {
        console.error("Error incrementing endpage mount count:", error);
      }
    };
    incrementEndpageMountCount();
  }, [urlCode]);

  // useEffect(() => {
  //   if (googletag) {
  //     const gtagScript = document.createElement("script");
  //     gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${googletag}`;
  //     gtagScript.async = true;
  //     document.head.appendChild(gtagScript);

  //     const inlineScript = document.createElement("script");
  //     inlineScript.innerHTML = `
  //       window.dataLayer = window.dataLayer || [];
  //       function gtag(){dataLayer.push(arguments);}
  //       gtag('js', new Date());
  //       gtag('config', '${googletag}');
  //       gtag('config', '${googletag2}');
  //       gtag('config', '${googletagNew}');
  //       gtag('config', '${googletagNew2}');
  //     `;
  //     document.head.appendChild(inlineScript);
  //   }
  // }, [googletag, googletag2, googletagNew, googletagNew2]);

  // 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트 크래프트

  useEffect(() => {
    if (craftTag) {
      const helmetScript = document.createElement("script");
      helmetScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id=${craftTag}';f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${craftTag}');
      `;
      document.head.appendChild(helmetScript);

      const noscriptDiv = document.createElement("div");
      noscriptDiv.innerHTML = `
        <!-- Google Tag Manager (noscript) -->
        <noscript>
          <iframe src="https://www.googletagmanager.com/ns.html?id=${craftTag}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
        </noscript>
        <!-- End Google Tag Manager (noscript) -->
      `;
      document.body.appendChild(noscriptDiv); // body에 추가
    }
  }, [craftTag]);

  // 당근 Pixel 로드
  useEffect(() => {
    if (carrotTag) {
      const karrotPixelScript = document.createElement("script");
      karrotPixelScript.src =
        "https://karrot-pixel.business.daangn.com/0.4/karrot-pixel.umd.js";
      karrotPixelScript.async = true;
      document.head.appendChild(karrotPixelScript);

      karrotPixelScript.onload = () => {
        if (window.karrotPixel) {
          window.karrotPixel.init("1735542452748400001");
          window.karrotPixel.track("ViewPage");
          console.log("Karrot Pixel initialized and ViewPage event tracked.");
        }
      };
      console.log("Karrot Pixel script loaded.");
    } else {
      console.log("Karrot Pixel not loaded (carrot is true).");
    }
  }, [carrotTag]);

  useEffect(() => {
    if (window.fbq && typeof window.fbq === "function") {
      window.fbq("track", "CompleteRegistration");
    }
  }, []);

  return (
    <div className="endPage">
      <Helmet>
        <title>이벤트 페이지</title>
        <script type="text/javascript">
          {`
            !function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)
              ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
              
              ttq.load('CMJMH3RC77U1UD4A67FG');
              ttq.page();
            }(window, document, 'ttq');
          `}
        </script>

        <script type="text/javascript">
          {`
      (function(d,a,b,l,e) {
        d[b]=d[b]||function(){(d[b].q=d[b].q||[]).push(arguments)};
        e=a.createElement(l);
        e.async=1;
        e.charset='utf-8';
        e.src='//static.dable.io/dist/dablena.min.js';
        var s=a.getElementsByTagName(l)[0];
        s.parentNode.insertBefore(e,s);
      })(window,document,'dablena','script');
      dablena('init', '001-011-666');
      dablena('track', 'CompleteRegistration');
    `}
        </script>
      </Helmet>

      <img src={`${process.env.REACT_APP_CDN_BASE}/images/rafinity/rafinityEndpage.png`} alt="end" />
    </div>
  );
}

export default ThankPage;
